import { throwIfAborted } from '../abort.js';
import { readAccountMethodLimits } from './method-limits.js';
export async function readPaymentMethodAllowances(options, signal) {
    if (options.methods.length === 0)
        return {};
    const controller = new AbortController();
    let expired = false;
    const cancel = () => controller.abort();
    const stopped = new Promise((_, reject) => {
        controller.signal.addEventListener('abort', () => {
            const error = new Error(expired ? 'onramp_allowances_timeout' : 'onramp_allowances_aborted');
            if (!expired)
                error.name = 'AbortError';
            reject(error);
        }, { once: true });
    });
    signal.addEventListener('abort', cancel, { once: true });
    const timer = setTimeout(() => {
        expired = true;
        cancel();
    }, 30_000);
    try {
        if (signal.aborted)
            cancel();
        return await Promise.race([readAllowances(options, controller.signal), stopped]);
    }
    finally {
        clearTimeout(timer);
        signal.removeEventListener('abort', cancel);
    }
}
async function readAllowances(options, signal) {
    throwIfAborted(signal);
    const context = await options.client.getContext(signal);
    throwIfAborted(signal);
    const result = {};
    // One authority read and serial quotes avoid a request burst from list rows.
    for (const method of options.methods) {
        throwIfAborted(signal);
        try {
            result[method] = await readAccountMethodLimits({ ...options, method }, signal, context);
        }
        catch {
            throwIfAborted(signal);
            result[method] = null;
            options.client.observeFunnel?.({
                stage: 'profile',
                outcome: 'error',
                errorCode: 'onramp_refresh_failed',
            });
        }
    }
    return result;
}
